import { render } from "./TabTiposAcomodacao.vue?vue&type=template&id=786f25b8&scoped=true"
import script from "./TabTiposAcomodacao.vue?vue&type=script&lang=js"
export * from "./TabTiposAcomodacao.vue?vue&type=script&lang=js"

import "./TabTiposAcomodacao.vue?vue&type=style&index=0&id=786f25b8&lang=css"
import "./TabTiposAcomodacao.vue?vue&type=style&index=1&id=786f25b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786f25b8"]])

export default __exports__